import { Navigate } from "react-router-dom";
import { usePermissions } from "../hooks/usePermissions";
import { useSelector } from "react-redux";
import { PERMISSIONS } from "../constants/permissions";

const ProtectedRoute = ({ permissionKey, children }) => {
  const { hasPermission } = usePermissions();
  const ne1Wms = useSelector((state) => state.user?.ne1Wms);

  const hasAccess = hasPermission(permissionKey);

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (ne1Wms === 0 && permissionKey !== PERMISSIONS.ADMIN_ROUTE) {
    return <Navigate to="/learnMore" replace />;
  }

  return children;
};

export default ProtectedRoute;
